import { render, staticRenderFns } from "./manage-groups.vue?vue&type=template&id=780784fe&scoped=true&"
import script from "./manage-groups.vue?vue&type=script&lang=js&"
export * from "./manage-groups.vue?vue&type=script&lang=js&"
import style0 from "./manage-groups.vue?vue&type=style&index=0&id=780784fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780784fe",
  null
  
)

component.options.__file = "manage-groups.vue"
export default component.exports